import request from '@/utils/request'

/**
 * 用户登录
 * @param {Object} data 登录数据
 */
export function loginApi(data) {
  return request({
    url: '/user/auth/login',
    method: 'post',
    data,
  });
}

/**
 * 用户注册
 * @param {Object} data 注册数据
 */
export function registerApi(data) {
  return request({
    url: '/user/auth/register',
    method: 'post',
    data,
  });
}

/**
 * 发送验证码 type=login 登录，type=register 注册
 * @param {Object} params 邮箱参数
 */
export function sendVerifyCodeApi(params) {
  return request({
    url: '/user/auth/sendVerifyCode',
    method: 'get',
    params,
  });
}

/**
 * 获取用户信息
 */
export function getUserInfoApi() {
  return request({
    url: '/user/auth/userInfo',
    method: 'get',
  });
}

/**
 * 刷新token
 */
export function refreshTokenApi(data) {
  return request({
    url: '/user/auth/refreshToken',
    method: 'post',
    data,
  });
}

/**
 * 修改密码
 * @param {Object} data 密码修改数据
 */
export function changePasswordApi(data) {
  return request({
    url: '/user/auth/changePassword',
    method: 'post',
    data,
  });
}

/**
 * 重置密码
 * @param {Object} data 密码重置数据
 */
export function resetPasswordApi(data) {
  return request({
    url: '/user/auth/resetPassword',
    method: 'post',
    data,
  });
}

/**
 * 发送重置密码验证码
 * @param {Object} params 邮箱参数
 */
export function sendResetPasswordCodeApi(params) {
  return request({
    url: '/user/auth/sendResetPasswordCode',
    method: 'get',
    params,
  });
}

/**
 * 用户登出
 */
export function logoutApi() {
  return request({
    url: '/user/auth/logout',
    method: 'post',
  });
}

/**
 * 检查邮箱是否已注册
 * @param {Object} params 邮箱参数
 */
export function checkEmailRegisteredApi(params) {
  return request({
    url: '/user/auth/checkEmail',
    method: 'get',
    params,
  });
}

/**
 * 验证token有效性
 */
export function verifyTokenApi() {
  return request({
    url: '/user/auth/verifyToken',
    method: 'get',
  });
}

/**
 * 更新用户头像
 * @param {Object} data 头像数据
 */
export function updateAvatarApi(data) {
  return request({
    url: '/user/auth/updateAvatar',
    method: 'post',
    data,
  });
}

/**
 * 使用授权码换取token
 * @param {string} code 授权码
 */
export function exchangeCodeForToken(data) {
  return request({
    url: '/user/auth/exchangeCode',
    method: 'post',
    data,
  });
}
